import React from 'react'
import hero from '../images/fursuit.JPG'
import SocialIconsFursuit from './SocialIconsFursuit'

export default function Fursuit() {
  return (
    <div className='main'>
      <h1>Awrrrrrf!</h1>
      <h2>call me daisy or hunty!</h2><br/>
      {/* profile icon */}
      <div style={{display:'flex',justifyContent:'center',width:'100%'}}><img style={{width:'100%'}} alt='phone dog' src={hero}/></div>
      {/* header title */}
      {/* <h3>my socials:</h3> */}
      {/* social icon links */}
      <SocialIconsFursuit />
      {/* link list */}
      <div style={{display:'flex', flexFlow:'column', marginTop:'8px'}}>
        <a href='mailto:huntysdoodles@gmail.com' className='button' target="_blank" rel="noopener noreferrer">💌 email me</a>
        <a href='https://flowerpuppy.online' className='button' target="_blank" rel="noopener noreferrer">🌷🐶 my music</a>
        <a href='https://t.me/huntyspupdates' className='button' target="_blank" rel="noopener noreferrer">💬 my art telegram channel</a>
        <a href='https://www.furtrack.com/index/character:daisy_huntysdoodles' className='button' target="_blank" rel="noopener noreferrer">📸 my furtrack</a>
      </div>
    </div>
  )
}
